import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

const CardText = styled(Box)`
  line-height: 1.2;
`;

export default CardText;
